(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dze-gallery-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dze-accessory-gallery')) {
  customElements.define('dze-accessory-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.accessory-gallery__track');
      this.slides = [...this.querySelectorAll('.accessory-gallery__slide')];
      this.dots = [...this.querySelectorAll('[data-gallery-index]')];
      this.dialog = this.querySelector('.accessory-lightbox');
      this.current = 0;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.querySelector('.accessory-gallery__dots').hidden = this.slides.length < 2;
      const arrows = this.querySelector('.accessory-gallery__arrows');
      if (arrows) arrows.hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-gallery-index')) this.go(Number(button.dataset.galleryIndex));
        if (button.hasAttribute('data-gallery-prev')) this.go(this.current - 1);
        if (button.hasAttribute('data-gallery-next')) this.go(this.current + 1);
        if (button.hasAttribute('data-gallery-open') && (!event.detail || !this.dragged)) this.openImage(Number(button.dataset.galleryOpen), button);
        if (button.hasAttribute('data-gallery-close')) this.dialog.close();
        if (button.hasAttribute('data-lightbox-prev')) this.showImage(this.lightboxIndex - 1);
        if (button.hasAttribute('data-lightbox-next')) this.showImage(this.lightboxIndex + 1);
      }, options);
      this.track.addEventListener('pointerdown', event => {
        this.dragged = false;
        this.pointerStart = { x: event.clientX, y: event.clientY, left: this.track.scrollLeft };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 8) this.dragged = true;
      }, options);
      this.track.addEventListener('pointercancel', () => { this.dragged = true; }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('keydown', event => {
        if (!this.dialog.open) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showImage(this.lightboxIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        this.go(this.lightboxIndex, 'instant');
        this.opener?.focus({ preventScroll: true });
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.pointerStart && Math.abs(this.track.scrollLeft - this.pointerStart.left) > 8) this.dragged = true;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.go(this.current, 'instant'));
      this.resize.observe(this.track);
      this.lightboxResize = new ResizeObserver(() => {
        if (this.dialog.open && this.lightboxTrack) this.showImage(this.lightboxIndex, 'instant');
      });
      this.lightboxResize.observe(this.dialog.querySelector('.accessory-lightbox__stage'));
      this.update();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow;
      }
      this.listeners?.abort();
      this.resize?.disconnect();
      this.lightboxResize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    openImage(index, opener) {
      this.opener = opener;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.showImage(index, 'instant');
      this.querySelector('[data-gallery-close]').focus();
    }
    showImage(index, behavior) {
      this.lightboxIndex = Math.max(0, Math.min(this.slides.length - 1, index));
      if (!this.lightboxTrack) {
        this.lightboxTrack = document.createElement('div');
        this.lightboxTrack.className = 'accessory-lightbox__track';
        this.lightboxSlides = this.slides.map(slide => {
          const source = slide.querySelector('[data-full-image]');
          const item = document.createElement('div');
          item.className = 'accessory-lightbox__slide';
          const image = document.createElement('img');
          image.className = 'accessory-lightbox__image';
          image.alt = source.querySelector('img').alt;
          image.dataset.src = source.dataset.fullImage;
          image.decoding = 'async';
          item.append(image);
          this.lightboxTrack.append(item);
          return item;
        });
        this.dialog.querySelector('.accessory-lightbox__stage').replaceChildren(this.lightboxTrack);
      }
      this.lightboxSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== this.lightboxIndex));
        if (Math.abs(slideIndex - this.lightboxIndex) <= 1) {
          const image = slide.querySelector('img');
          if (!image.getAttribute('src')) image.src = image.dataset.src;
        }
      });
      this.lightboxTrack.scrollTo({
        left: this.lightboxIndex * this.lightboxTrack.clientWidth,
        behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth')
      });
      this.dialog.querySelector('.accessory-lightbox__count').textContent = `${this.lightboxIndex + 1} / ${this.slides.length}`;
      this.dialog.querySelector('[data-lightbox-prev]').disabled = this.lightboxIndex === 0;
      this.dialog.querySelector('[data-lightbox-next]').disabled = this.lightboxIndex === this.slides.length - 1;
      this.dialog.querySelector('.accessory-lightbox__controls').hidden = this.slides.length < 2;
    }
    go(index, behavior) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      const slide = this.slides[index];
      const left = this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
    }
    update() {
      const left = this.track.getBoundingClientRect().left;
      this.current = this.slides.reduce((best, slide, index) =>
        Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
      this.dots.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.current)));
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (previous) previous.disabled = this.current === 0;
      if (next) next.disabled = this.current === this.slides.length - 1;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dze-label-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('play', (event) => {
  if (!event.target.matches('.label-details__samples audio')) return;
  document.querySelectorAll('.label-details__samples audio').forEach((audio) => {
    if (audio !== event.target) audio.pause();
  });
}, true);
document.addEventListener('contextmenu', (event) => {
  if (event.target.matches('.label-details__samples audio')) event.preventDefault();
});
  } catch(e) { console.error(e); }
})();

})();
